/** Speech-bubble + paw illustration for Unlimited Ask Dynamo carousel card. */
export function AskDynamoChatIllustration({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 88 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
    >
      <path
        d="M8 12h52a8 8 0 0 1 8 8v28a8 8 0 0 1-8 8H36l-10 10v-10H8a8 8 0 0 1-8-8V20a8 8 0 0 1 8-8z"
        fill="url(#chatBubbleGrad)"
        stroke="var(--color-ask-dynamo)"
        strokeWidth="1.5"
      />
      <path
        d="M44 20h36a6 6 0 0 1 6 6v22a6 6 0 0 1-6 6H56l-8 8v-8H44a6 6 0 0 1-6-6V26a6 6 0 0 1 6-6z"
        fill="white"
        stroke="var(--color-ask-dynamo)"
        strokeWidth="1.5"
      />
      <ellipse cx="58" cy="34" rx="3" ry="3.5" fill="var(--color-ask-dynamo)" opacity="0.85" />
      <ellipse cx="66" cy="31" rx="3" ry="3.5" fill="var(--color-ask-dynamo)" opacity="0.85" />
      <ellipse cx="74" cy="34" rx="3" ry="3.5" fill="var(--color-ask-dynamo)" opacity="0.85" />
      <ellipse cx="62" cy="40" rx="2.5" ry="3" fill="var(--color-ask-dynamo)" opacity="0.7" />
      <ellipse cx="70" cy="40" rx="2.5" ry="3" fill="var(--color-ask-dynamo)" opacity="0.7" />
      <path
        d="M22 28l2 4 4 1-3 3 1 4-4-2-4 2 1-4-3-3 1 2-4-4-1 3-3z"
        fill="var(--color-ask-dynamo)"
        opacity="0.7"
      />
      <circle cx="78" cy="14" r="2" fill="var(--color-ask-dynamo)" opacity="0.5" />
      <circle cx="82" cy="22" r="1.5" fill="var(--color-ask-dynamo)" opacity="0.4" />
      <defs>
        <linearGradient id="chatBubbleGrad" x1="8" y1="12" x2="68" y2="56" gradientUnits="userSpaceOnUse">
          <stop stopColor="var(--color-ask-dynamo-surface)" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
      </defs>
    </svg>
  )
}
